/**
 * hrd.Toolbox.js
 */
hrd.Toolbox = hrd.Class.extend({
	PATTERN_DECIMAL_2_DIGITS: ",.2f",
	PATTERN_PERCENT_2_DIGITS: ",.2%",
	PATTERN_AMOUNT_2_DIGITS: "$,.2f",
	PATTERN_INTEGER: ",.0f",
	init: function(options) {
		var defaults = {
			impl: 'hrd.Toolbox',
		};
		this._super($.extend({}, defaults, options));
		if (window['d3'] !== undefined && window['d3locale'] == undefined) {
			let symbol = this.get('globals.prefs.tenant.currencySymbol', hrd, '€');
			window['d3locale'] = d3.formatLocale({
				decimal: ",",
				thousands: ".",
				grouping: [3],
				currency: ["", " " + symbol]
			});
		}
	},
	generateMarker: function(opts) {
		opts = $.extend({
			max: 100000,
			prefix: '',
			suffix: '',
		}, opts);

		return opts.prefix + Math.trunc(Math.random() * opts.max) + opts.suffix;
	},
	isEmpty: function(s) {
		return hrd.utils.isEmpty(s);
	},
	isNotEmpty: function(s) {
		return hrd.utils.isNotEmpty(s);
	},
	replaceParams: function(template, params) {
		return hrd.utils.replaceParams(template, params);
	},
	escapeTooltip: function(tooltip) {
		if (tooltip != undefined) {
			tooltip = tooltip.replace(new RegExp('"', 'g'), "&quot;");
		}
		return tooltip;
	},
	leftPad: function(str, size, padStr) {
		padStr = padStr || ' ';
		size = size || 5;
		var padding = Array(size + 1).join(padStr)
		return ('' + padding + str).slice(-size);
	},
	rightPad: function(str, size, padStr) {
		padStr = padStr || ' ';
		size = size || 5;
		var padding = Array(size + 1).join(padStr)
		return ('' + str + padding).substring(0, size);
	},
	capitalize: function(s) {
		return (typeof s !== 'string') ? '' : s.charAt(0).toUpperCase() + s.slice(1);
	},
	startCountdownTimer: function(options) {
		let countdownTimer = new hrd.utils.CountdownTimer(options);
		return countdownTimer.start();
	},
	downloadImage: function(uid, options) {
		options = options || {};
		let url = `${hrd.globals.downloadURI}?uid=${uid}`;
		let th = '';
		let cropString = 'F';
		let widthHex = 'FFF';
		let heightHex = 'FFF';

		if (!!options.crop) {
			cropString = 'C';
		}

		if (options.width != null && options.width >= 0) {
			widthHex = this.leftPad(options.width.toString(16), 3, '0');
		}

		if (options.height != null && options.height >= 0) {
			heightHex = this.leftPad(options.height.toString(16), 3, '0');
		}

		th = `${cropString}${widthHex}${heightHex}`;

		return `${url}&th=${th}`;
	},
	/**
	 * Given w / h return thumbnail encoded string. keepratio is true if missing
	 * TODO: create inverse function
	 */
	encodeThumbDimensions: function(width, height, keepRatio) {
		keepRatio = keepRatio == undefined ? true : keepRatio;
		var kr = (keepRatio) ? 'F' : '0';
		var w = this.leftPad(width.toString(16), 3, '0');
		var h = this.leftPad(height.toString(16), 3, '0');
		var th = kr + w + h;
		return th;
	},
	formatDate: function(date, fromPattern, toPattern) {
		return moment(date, fromPattern).format(toPattern);
	},
	formatNumber: function(value, pattern) {
		return d3locale.format(pattern)(value);
	},
	formatDecimal: function(value, pattern) {
		return d3locale.format(this.PATTERN_DECIMAL_2_DIGITS)(value);
	},
	formatInteger: function(value) {
		return d3locale.format(this.PATTERN_INTEGER)(value);
	},
	formatAmount: function(value) {
		return d3locale.format(this.PATTERN_AMOUNT_2_DIGITS)(value);
	},
	formatPercent: function(value, pattern) {
		pattern = pattern || this.PATTERN_PERCENT_2_DIGITS;
		return d3locale.format(pattern)(value);
	},
	formatBoolean: function(value) {
		if (typeof value == 'string') {
			var sValue = value.trim();
			return sValue == '1' || sValue == 'true';
		} else {
			return value; // to be implemented
		}
	},
	formatDuration: function(value, pattern, units) {
		units = units || 'seconds';
		return moment.duration(value, units).format(pattern, { trim: false, useGrouping: false });
	},
	humanizeDuration: function(duration, options) {
		options = $.extend({ maxUnit: 'years', minUnit: 'seconds' }, options);
		let momentDuration = null;

		if (typeof duration === 'string' || typeof duration === 'number') {
			momentDuration = moment.duration(duration * 1)
		} else {
			momentDuration = duration;
		}

		if (!momentDuration) {
			return null;
		}

		const years = momentDuration.years() === 1 ? xlate('common.duration.year') : momentDuration.years() && xlate('common.duration.years', { years: momentDuration.years() });
		const months = momentDuration.months() === 1 ? xlate('common.duration.month') : momentDuration.months() && xlate('common.duration.months', { months: momentDuration.months() });
		const days = momentDuration.days() === 1 ? xlate('common.duration.day') : momentDuration.days() && xlate('common.duration.days', { days: momentDuration.days() });
		const hours = momentDuration.hours() === 1 ? xlate('common.duration.hour') : momentDuration.hours() && xlate('common.duration.hours', { hours: momentDuration.hours() });
		const minutes = momentDuration.minutes() === 1 ? xlate('common.duration.minute') : momentDuration.minutes() && xlate('common.duration.minutes', { minutes: momentDuration.minutes() });
		const seconds = momentDuration.seconds() === 1 ? xlate('common.duration.second') : momentDuration.seconds() && xlate('common.duration.seconds', { seconds: momentDuration.seconds() });
		const mapper = {
			years: 0,
			months: 1,
			days: 2,
			hours: 3,
			minutes: 4,
			seconds: 5,
		};
		const full = [years, months, days, hours, minutes, seconds];
		const elements = full.slice(mapper[options.maxUnit], mapper[options.minUnit] + 1);

		const firstArray = elements.filter((t) => !!t);
		const last = firstArray.pop();
		const finalArray = [firstArray.join(', '), last].filter((t) => !!t);

		return finalArray.join(xlate('common.duration.separator'));
	},
	convertBoolean: function(value) {
		// as of now it is similar to formatBoolean
		return this.formatBoolean(value);
	},
	get: function(property, object, defaultValue) {
		var v = hrd.utils.getValueByPath(object, property);
		return (v == undefined) ? defaultValue : v;
	},
	/**
	 * Changes XML to JSON
	 * Modified version from here: http://davidwalsh.name/convert-xml-json
	 *
	 * Usage:
	 *
	 * 1. If you have an XML file URL:
	 *
	 * const response = await fetch('file_url');
	 * const xmlString = await response.text();
	 * var XmlNode = new DOMParser().parseFromString(xmlString, 'text/xml');
	 * xmlToJson(XmlNode);
	 *
	 * 2. If you have an XML as string:
	 *
	 * var XmlNode = new DOMParser().parseFromString(yourXmlString, 'text/xml');
	 * xmlToJson(XmlNode);
	 *
	 * 3. If you have the XML as a DOM Node:
	 *
	 * xmlToJson(YourXmlNode);
	 * @param {string} xml XML DOM tree
	 */
	xmlToJson: function(xml) {
		// Create the return object
		var obj = {};

		if (xml.nodeType == 1) {
			// element
			// do attributes
			if (xml.attributes.length > 0) {
				obj["_attributes"] = {};
				for (var j = 0; j < xml.attributes.length; j++) {
					var attribute = xml.attributes.item(j);
					obj["_attributes"][attribute.nodeName] = attribute.nodeValue;
				}
			}
		} else if (xml.nodeType == 3) {
			// text
			obj = xml.nodeValue;
		}

		// do children
		// If all text nodes inside, get concatenated text from them.
		var textNodes = [].slice.call(xml.childNodes).filter(node => node.nodeType === 3);
		if (xml.hasChildNodes() && xml.childNodes.length === textNodes.length) {
			obj = [].slice.call(xml.childNodes).reduce((text, node) => text + node.nodeValue, "");
		} else if (xml.hasChildNodes()) {
			for (var i = 0; i < xml.childNodes.length; i++) {
				var item = xml.childNodes.item(i);
				var nodeName = item.nodeName;
				if (nodeName != '#text') {
					if (typeof obj[nodeName] == "undefined") {
						obj[nodeName] = this.xmlToJson(item);
					} else {
						if (typeof obj[nodeName].push == "undefined") {
							var old = obj[nodeName];
							obj[nodeName] = [];
							obj[nodeName].push(old);
						}
						obj[nodeName].push(this.xmlToJson(item));
					}
				}
			}
		}
		return obj;
	},
	createIconTemplate: function(iconOptions) {
		if (iconOptions.hide === true) {
			return '';
		} else {
			iconOptions['class'] = iconOptions['class'] || 'simple-icon';
			var colorPart = iconOptions.color != undefined ? ' style="color:{color}"' : '';
			var tooltipPart = iconOptions.tooltip != undefined ? ' title="{tooltip}"' : '';
			var tmpl = '<span class="{class}"><i class="f-icon {icon}"' + colorPart + tooltipPart + '></i></span>';
			return this.replaceParams(tmpl, iconOptions);
		}
	},
	/**
	 * Utility used to convert a string to a template-literal and interpolate it with given attributes
	 */
	toTemplate: function(template, vars) {
		vars = vars || {};
		const handler = new Function('vars', [
			'const tagged = (' + Object.keys(vars).join(', ') + ') => `' + template + '`;',
			'return tagged(...Object.values(vars));'
		].join('\n'));
		return handler(vars);
	},
	/**
	 * ASCII to Unicode (decode Base64 to original data)
	 * @param {string} b64
	 * @return {string}
	 */
	atou: function(b64) {
		return decodeURIComponent(escape(atob(b64)));
	},
	/**
	 * Unicode to ASCII (encode data to Base64)
	 * @param {string} data
	 * @return {string}
	 */
	utoa: function(data) {
		return btoa(unescape(encodeURIComponent(data)));
	},
	/**
	 * return a simple object with a property set to the given value
	 * if property is missing, the "id" is used
	 * if value is undefined, undefined will be returned
	 */
	wrapToObject: function(value, property) {
		let obj = undefined;
		if (value != undefined) {
			property = property || 'id';
			obj = {};
			obj[property] = value;
		}
		return obj;
	}
});